import { render, staticRenderFns } from "./MessageValidation.vue?vue&type=template&id=15c1d5f8&scoped=true"
import script from "./MessageValidation.vue?vue&type=script&lang=js"
export * from "./MessageValidation.vue?vue&type=script&lang=js"
import style0 from "./MessageValidation.vue?vue&type=style&index=0&id=15c1d5f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c1d5f8",
  null
  
)

export default component.exports